import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import OfferingModal from './OfferingModal';

const Orders = () => {


    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [orders, setOrders] = useState([
        {
            dateTime: '2025-01-01 14:30',
            orderId: 'ORD-001',
            userId: 'USR-001',
            amount: '₹5000',
            status: 'Delivered',
            address: '123, Some Street, City',
            productId: 'PRD-001',
        },
        {
            dateTime: '2025-01-02 09:15',
            orderId: 'ORD-002',
            userId: 'USR-002',
            amount: '₹3000',
            status: 'Pending',
            address: '456, Another Street, City',
            productId: 'PRD-002',
        },
    ]);
    const [filteredOrders, setFilteredOrders] = useState(orders);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Effect to handle filtering
    useEffect(() => {
        const filtered = orders.filter((order) =>
            Object.values(order).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredOrders(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, orders]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);
    const currentData = filteredOrders.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Order List</h1>
            </div>

            {/* Search Filter */}
            <div className="filter-search">
                <div className="filter-search-input">
                    <input
                        type="search"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                    <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                </div>
            </div>

            {/* Orders Table */}
            <div className="orders-table customer-table">
                <table>
                    <thead>
                        <tr>
                            <th>Date/Time</th>
                            <th>Order ID</th>
                            <th>User ID</th>
                            <th>Amount</th>
                            <th>Status (Delivery/)</th>
                            <th>Address</th>
                            <th>View Product</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((order, index) => (
                                <tr key={index}>
                                    <td>{order.dateTime}</td>
                                    <td>{order.orderId}</td>
                                    <td>{order.userId}</td>
                                    <td>{order.amount}</td>
                                    <td>{order.status}</td>
                                    <td>{order.address}</td>
                                    <td>
                                        <button className="view-product-button">
                                            <i className="fas fa-eye"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" style={{ textAlign: 'center' }}>No data found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="pagination">
                <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => paginate(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </button>
                ))}
                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
            <OfferingModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default Orders;
